import { ca } from '@cian/analytics';

import { IOffer } from '../../../../types/offer';

export function trackWriteClick(offer: IOffer, position: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'message',
    products: [
      {
        id: offer.id,
        offerType: 'offer',
        position,
      },
    ],
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        /* istanbul ignore next */
        opponent_id: offer.user?.cianUserId,
      },
    },
  });
}
